import React, { useState } from "react";
import { injectStripe, CardElement } from "react-stripe-elements";
import { Spinner } from "react-bootstrap";
import { useFormik } from "formik";
import More from "./More";
import * as Yup from "yup";
import { addPaymentMethod } from "../../../../../api/payment_methods";
import { subscribeToTipjar, updateCurrentUser } from "../../../../../api/users";
import { updateCurrentUserRedux } from "../../../../../api/helper";

const style = {
  base: {
    color: "#32325d",
    fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
    fontSmoothing: "antialiased",
    fontSize: "16px",
    "::placeholder": {
      color: "#aab7c4",
    },
  },
  invalid: {
    color: "#fa755a",
    iconColor: "#fa755a",
  },
};

const mystyle = {
  fontWeight: 300,
  fontSize: "12px",
  lineHeight: "24px",
  letterSpacing: "0.1px",
  textAlign: "left",
};

function TipjarCheckoutForm(props) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [seemore, setSeeMore] = useState(false);

  const { handleSubmit, handleChange, values, errors } = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      paypal_me_tag: "",
    },
    validationSchema: Yup.object({
      first_name: Yup.string().required(),
      last_name: Yup.string().required(),
      paypal_me_tag: Yup.string().required(),
    }),
    onSubmit: async (values) => {
      console.log("values =>", values);
      try {
        setLoading(true);
        setError(null);
        let { paymentMethod } = await props.stripe.createPaymentMethod({
          card: props.elements.getElement("card"),
          type: "card",
          billing_details: {
            email: props.current_user.email,
            name: values.first_name + " " + values.last_name,
          },
        });
        let {
          data: {
            payment_method: { payment_method_id },
          },
        } = await addPaymentMethod({
          payment_method_id: paymentMethod.id,
          object: paymentMethod,
        });
        await subscribeToTipjar({ payment_method_id });
        await updateCurrentUser({
          user: {
            artist_profile: {
              paypal_me_tag: values.paypal_me_tag,
            },
          },
        });
        updateCurrentUserRedux();
        props.onCheckoutDone();
      } catch (error) {
        console.log("error => ", error);
        setError(error);
      } finally {
        setLoading(false);
      }
    },
  });
  const showSeeMore = () => {
    setSeeMore(true);
  };
  const onBack = () => {
    setSeeMore(false);
  };

  return seemore ? (
    <More onBack={onBack} />
  ) : (
    <form onSubmit={handleSubmit}>
      <div className="intro">
        <p>
          Think of it as an open instrument case on a busy city street, chock full of stray bills and coins signaling just how talented people think
          you are.
        </p>
        <p className="font-weight-bold text-black">After all, money talks louder than words.</p>
        <p>
          Activate your TipJar for just $1/month and start accepting those dollars. And don't worry, no heartless vagabond is gonna swipe your
          earnings and run off. At UNIFI, there are no service charges, percentages taken, or hidden fees ever.
        </p>
      </div>
      <h3 className="text-green">Price: $1/month</h3>
      <small>Cancel anytime</small>
      <div className="row mt-5">
        {error && (
          <div className="col-100 mb-3">
            <small className="text-danger">There was an error, Please make sure to enter a valid card details or please try again</small>
          </div>
        )}
        <div className="col">
          <input
            onChange={handleChange}
            value={values.first_name}
            name="first_name"
            placeholder="First Name"
            className={`form-control ${errors.first_name ? "error" : ""}`}
          />
        </div>
        <div className="col">
          <input
            onChange={handleChange}
            value={values.last_name}
            name="last_name"
            placeholder="Last Name"
            className={`form-control ${errors.last_name ? "error" : ""}`}
          />
        </div>
      </div>

      <CardElement className="my-3" style={style} />
      <div className="text-left">
        <input
          onChange={handleChange}
          value={values.paypal_me_tag}
          name="paypal_me_tag"
          placeholder="PayPal Email where you want to receive tips"
          className={`form-control ${errors.paypal_me_tag ? "error" : ""}`}
        />
      </div>

      <p className="my-3" style={mystyle}>
        By clicking below, you agree to UNIFI's MUSIC{" "}
        <a href="/terms-of-use" target="_blank">
          Terms of Use
        </a>
        , and have read & understand our{" "}
        <a href="/privacy-policy" target="_blank">
          Privacy Policy
        </a>{" "}
        and{" "}
        <a href="/eula" target="_blank">
          End User License Agreement
        </a>
        .
      </p>

      <button disabled={loading} className="my-3 text-uppercase btn btn-lg btn-primary">
        {loading ? <Spinner animation="border" variant="light" size="sm" role="status" /> : "Let's do this!"}
      </button>
    </form>
  );
}

export default injectStripe(TipjarCheckoutForm);
